module.exports = __webpack_public_path__ + "image-10cdab4a2da4.png";